import { toast } from 'react-toastify';

// Tải file báo cáo có kèm token.
//
// Vì sao cần: các nút xuất Excel trước đây gọi window.open(url). Đó là một lần điều hướng của
// trình duyệt, mà điều hướng thì không mang theo header nào — nên từ khi report API bắt token
// (commit 02fb283 bên backend), mọi nút xuất file mở ra một tab hiện đúng dòng chữ
// {"code":401,"message":"Authorization header is required"} thay vì tải file. Bản thân endpoint
// vẫn đúng: gọi kèm Authorization thì trả 200 và file thật.
//
// Ở đây tải bằng fetch kèm header, rồi lưu blob qua một thẻ <a download> tạm.

// Máy chủ không đặt Content-Disposition nên tên file do phía này quyết định. Lấy theo đường dẫn
// để mỗi báo cáo ra một tên riêng, kèm mốc thời gian tải cho khỏi đè lên nhau trong thư mục Tải về.
function tenFileTuUrl(url) {
  try {
    const path = new URL(url, window.location.origin).pathname;
    const sau = path.split('/report/agency/')[1] || path;
    const phan = sau.split('/').filter(Boolean).slice(1); // bỏ id đơn vị
    const ten = phan.filter(p => p !== 'excel' && p !== 'pdf').join('-') || 'bao-cao';
    const d = new Date();
    const hai = n => String(n).padStart(2, '0');
    const moc = `${d.getFullYear()}${hai(d.getMonth() + 1)}${hai(d.getDate())}-${hai(d.getHours())}${hai(d.getMinutes())}`;
    return `${ten}-${moc}.xlsx`;
  } catch (e) {
    return 'bao-cao.xlsx';
  }
}

export async function downloadReportFile(url, tenFile) {
  try {
    const res = await fetch(url, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('access-token') }
    });

    if (!res.ok) {
      // Máy chủ trả JSON khi lỗi, kể cả trên endpoint vốn sinh file nhị phân.
      let thongBao = `Tải file thất bại (HTTP ${res.status})`;
      try {
        const j = JSON.parse(await res.text());
        if (j && j.message) thongBao = j.message;
      } catch (e) {
        // giữ nguyên thông báo mặc định
      }
      toast.error(thongBao);
      return false;
    }

    const blob = await res.blob();
    // Không có dòng nào thì máy chủ vẫn trả 200 với file rỗng; nói thẳng còn hơn để người dùng mở
    // một file trắng rồi tưởng hỏng.
    if (blob.size === 0) {
      toast.warning('Không có dữ liệu để xuất trong khoảng thời gian đã chọn');
      return false;
    }

    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = tenFile || tenFileTuUrl(url);
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Thu hồi sau một nhịp: thu hồi ngay có trình duyệt huỷ luôn lần tải.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    return true;
  } catch (err) {
    toast.error('Không kết nối được tới máy chủ báo cáo');
    return false;
  }
}

export default downloadReportFile;
